import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ab76ece&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=7ab76ece&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab76ece')) {
      api.createRecord('7ab76ece', component.options)
    } else {
      api.reload('7ab76ece', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ab76ece&", function () {
      api.rerender('7ab76ece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/index.vue"
export default component.exports